module.exports = __webpack_public_path__ + "static/media/vehicle-icon.ce2a9b78.svg";